import type { FC } from "react";
import React from "react";
import type { TrackEvent } from "src/state/Track/TrackCubit";
import { authenticationState, tracker, userPreferences } from "src/state/state";
import { AppQueryPopupsController } from "../AppQueryPopupsBloc";
import SessionConfirmation from "../../SessionConfirmation/SessionConfirmation";

const SessionConfirmationDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const handleConfirmSession = () => {
    tracker.track("Session Confirmed" as TrackEvent);
    AppQueryPopupsController.closePopup();
  };

  const handleLogOut = () => {
    tracker.track("Session Logged Out" as TrackEvent);

    void authenticationState.logout().then(() => {
      AppQueryPopupsController.closePopup();

      window.location.href = returnUrl;
    });
  };

  return (
    <SessionConfirmation
      firstName={userPreferences.firstName}
      lastName={userPreferences.lastName}
      onConfirmed={handleConfirmSession}
      onLogout={handleLogOut}
    />
  );
};

export default SessionConfirmationDialog;
